export enum PropertyTypes {
    flats = 4,
    houses = 6,
    lands = 3,
    commercialObjects = 2,
    hospitality = 7,
    housesToRent = 8,
    recreationObjects = 10,
    other = 11,
    historicalObjects = 5,
    agricultureObjects = 1,
    commercialSpaces = 9,
}

export interface BrokerOfferPhoto {
    brokerOfferPhotoId: number;
    remaxOfferPhotoId: number;
    position: number;
    file: string;
    thumbnailFile: string;
}

export interface BrokerOffer {
    brokerOfferId: number;
    code: string;
    userId: number;
    officeId: number;
    detailUrl: string;

    //TIME RELATED FIELDS ------------
    dateOfReconstruction: string;
    dateOfApproval: string;
    availableFrom: string; // todo date

    //PROPERTY TYPE & CATEGORY -------------------
    offerType: "Prodej" | "Pronájem";
    ownership: "Osobní" | "Družstevní" | "Ostatní";
    typeOfProperty: string; // todo
    typeOfBuilding: string; // todo
    propertyCondition: string; // todo
    commercialPropertyType: string; // todo;
    commercialObjectType: string; // todo;
    hospitalityType: string; // todo;
    landType: string; // todo;

    //DESCRIPTIONS ---------------------
    title: string;
    standardizedTitle: string;
    publicFacilitiesFlags: number;
    description: string;
    transportationFlags: number;
    openHouse: string;

    //FEATURES---------------------
    balcony: string;
    lodzie: string;
    garage: string;
    parking: string;
    parkingNumber: string;
    energyLabel: string;
    terrace: string;
    waterFlags: number;
    cellar: string;
    lift: boolean;
    communicationFlags: number;
    equipment: boolean;
    wasteFlags: number;
    heatingFlags: number;
    gasFlags: number;

    sizeTotal: number;
    sizeLand: number;
    totalFloor: string;
    propertyFloor: number;

    //META INFORMATION & META FLAGS -----------------
    reserved: boolean;
    lastEdit: string; // todo date
    active: boolean;
    exclusive: boolean;
    visibility: "None" | "Everyhwere" | "Office";

    //PRICE RELATED FIELDS -------------
    price: number;
    showPrice: boolean;
    showDiscount: boolean;
    priceUnit: string;
    priceDescription: string;
    priceCurrency: string;
    currencyFormatted: string;

    //ADDRESS + LOCATION --------------
    city: string;
    region: { regionId: number; name: string };
    subregion: { subregionId: number; name: string };
    district: string;
    street: string;
    streetNumber: string;
    locality: string;
    //GPS
    lat: string;
    lng: string;

    //PHOTOS & VIDEOS
    thumbnail?: string;
    photos: BrokerOfferPhoto[];
    videoURL: string;

    //OTHER
    priceFormatted: string;
}

export interface FlatOffer extends BrokerOffer {
    dispositions: string; // todo
}
export interface HouseOffer extends BrokerOffer {
    housePosition: string; // todo;
}
export interface LandOffer extends BrokerOffer {
    landTypes: string; // todo;
}
export interface CommercialOffer extends BrokerOffer {
    hospitalityType: string; // todo;
    commercialPropertyType: string; // todo;
    commercialObjectType: string; // todo;
}

export type AnyOfferTypes = BrokerOffer | FlatOffer | HouseOffer | LandOffer | CommercialOffer;

export interface OffersSearch {
    offers: BrokerOffer[];
    count: number;
    page: number;
    prevPage?: number;
    nextPage: number;
}
